import i18n from "../../localization";
import {
    INITIALIZE,
    SET_LOCALE, SET_LOCALI
} from "../mutations/restaurant";
import {point} from "@turf/helpers";

const restaurant = {
    namespaced: true,
    state: {
        id: null,
        targa: null,//kk0000
        locali: [], //tutti i locali
        locale: null, //locale selezionato,
        servizi_attivi: null, //ristorante servizi attivi
        impostazioni: null,
        monete: [],
        maps_api_key: null,
        punti_di_servizio: [],
        franchising: false,
        f_stripe: false,
        f_modalita_fiera: false,
        f_distretto: false,
        specific_translations: null,
        f_deliverect: false
    },
    mutations: {
        [INITIALIZE](state, payload) {
            state.locali = payload.locali;
            state.servizi_attivi = payload.servizi_attivi;
            state.id = payload.id;
            state.targa = payload.targa;
            state.impostazioni = payload.impostazioni;
            state.monete = payload.monete;
            state.punti_di_servizio = payload.punti_di_servizio;
            state.franchising = payload.franchising;
            state.f_stripe = payload.f_stripe;
            state.f_modalita_fiera = payload.f_modalita_fiera;
            state.f_distretto = payload.f_distretto;
            state.specific_translations = payload.specific_translations;
            state.f_deliverect = payload.f_deliverect;

        },
        [SET_LOCALE](state, payload) {
            state.locale = payload.locale;
        },
        [SET_LOCALI](state, payload) {
            state.locali = payload.locali;
        }
    },
    getters: {
        graphicLayout: (state) => {
            if (state.impostazioni && state.impostazioni.layout_grafica) {
                return !!parseInt(state.impostazioni.layout_grafica);
            }

            return false;
        },
        enableReservations: (state) => {
            return !!(state.servizi_attivi && state.servizi_attivi.f_prenotazioni_tavoli &&
                state.locale && state.locale.configurazione_prenotazioni &&
                state.locale.configurazione_prenotazioni.f_attivo);
        },
        enableFidelityCard: (state) => {
            return state.impostazioni && state.impostazioni.f_fidelity_card;
        },
        enableMessaging: (state) => {
            return state.locale && state.locale.f_messaggistica;
        },
        enableCoupons: (state) => {
            return state.impostazioni && state.impostazioni.f_codici_sconto;
        },
        openingHours: (state) => {
            let orari_array = [];
            for (let i = 0; i < 7; i++) {
                orari_array.push([]);
            }

            state.locale.orari_ristorante.forEach((item) => {
                let pos = (item.fascia === "F1" ? 0 : 1);
                orari_array[(item.giorno - 1)].splice(pos, 0, (item.dalle_ore !== null && item.alle_ore !== null) ? item.dalle_ore.substring(0, 5) + " - " + item.alle_ore.substring(0, 5) : "chiuso");
            });

            return orari_array;

        },
        localeDeliveryActive: (state) => {
            try {
                return !!state.locale.configurazione_delivery.f_attivo
            } catch (e) {
                return false
            }
        },
        localeCurrency: (state) => {
            try {
                return state.monete[state.locale.moneta].simbolo;
            } catch (e) {
                return null;
            }
        },
        localePhotos: (state) => {
            try {
                const foto = JSON.parse(state.locale.foto);
                if (foto) {
                    return foto;
                }

                return [];
            } catch (e) {
                return [];
            }
        },
        localeAddress: (state) => {
            try {
                return state.locale.indirizzo + ', ' + state.locale.civico + ' - ' + state.locale.cap + ' ' +
                    state.locale.citta + ' (' + state.locale.provincia + ') - ' + state.locale.stato;
            } catch (e) {
                return '';
            }
        },
        localeDescription: (state) => (maxLength) => {
            try {
                if (maxLength && state.locale.traduzione.descrizione.length > maxLength) {
                    return state.locale.traduzione.descrizione.replace(/\n/g, '<br>').substr(0, maxLength) + "...";
                }

                return state.locale.traduzione.descrizione.replace(/\n/g, '<br>');
            } catch (e) {
                return '';
            }

        },
        localeImageCode: (state) => (idx) => {
            try {
                return JSON.parse(state.locale.foto)[idx].codice;
            } catch (e) {
                return null;
            }
        },
        pos: (state) => (room_id) => {
            const pos = [];
            if (state.punti_di_servizio) {
                state.punti_di_servizio.forEach((point) => {
                    state.locali.filter((room) => {
                        if (room_id) {
                            return room.id === room_id;
                        }

                        return true;
                    }).forEach((room) => {
                        if (room.id & point.mask_locali) {
                            if (
                                !pos.find((item) => {
                                    return item.id === point.id;
                                })
                            ) {
                                pos.push(point);
                            }
                        }
                    });
                });
            }

            return pos;
        },
        rooms: (state) => (pointId) => {
            if (pointId) {
                const point = state.punti_di_servizio.find((item) => item.id === pointId);
                const roomsIds = point.conf_ordini_prenotazioni_pds.map((conf) => conf.id_locale);

                return state.locali.filter((room) => roomsIds.includes(room.id));
            }

            return state.locali;
        },
        isMultiChoice: (state, getters) => {
            return (state.f_modalita_fiera &&
                    state.punti_di_servizio &&
                    (state.punti_di_servizio.length > 1 || getters.restaurantServices().length > 1)) ||
                (state.franchising && getters.rooms().length > 1)

        },
        roomServices: () => (room, withReserve = false) => {
            const servizi = [];
            if (room.configurazione_takeaway.f_attivo) {
                servizi.push({type: room.configurazione_takeaway.tipo_orario, order: 1});
            }

            if (room.configurazione_delivery.f_attivo) {
                servizi.push({type: room.configurazione_delivery.tipo_orario, order: 2});
            }

            if (room.configurazione_mangia_ristorante.f_attivo) {
                servizi.push({
                    type: room.configurazione_mangia_ristorante.tipo_orario,
                    order: 3,
                });
            }

            if (room.configurazione_dil.f_attivo) {
                servizi.push({type: room.configurazione_dil.tipo_orario, order: 4});
            }

            if (room.configurazione_ordina_tavolo.f_attivo) {
                servizi.push({
                    type: room.configurazione_ordina_tavolo.tipo_orario,
                    order: 5,
                });
            }

            if (withReserve) {
                if (room.configurazione_prenotazione.f_attivo) {
                    servizi.push({
                        type: room.configurazione_prenotazione.tipo_orario,
                        order: 6,
                    });
                }
            }

            return servizi;
        },
        restaurantServices: (state, getters) => (withReserve = false) => {
            let servizi = [];
            const uniqueServices = [];

            getters.rooms().forEach((room) => {
                servizi = servizi.concat(getters.roomServices(room, withReserve));
            });

            servizi.sort((service1, service2) => service1.order - service2.order);

            servizi.forEach(service => {
                const index = uniqueServices.findIndex(item => item === service.type);
                if (index < 0) {
                    uniqueServices.push(service.type);
                }
            });

            return uniqueServices;
        },
        specificTranslation: (state) => (value) => {
            try {
                return state.specific_translations[i18n.locale][value];
            } catch (e) {
                return 'N/A';
            }
        },
        serviceInfo: (state, getters) => (service, overrideName) => {
            switch (service) {
                case 'TAKEAWAY':
                    return {
                        nome: i18n.t('takeaway'),
                        descrizione: getters.specificTranslation('presso_tipo_ristorante'),
                        img: '/img/be/ico-takeaway.png',
                    };
                case 'DELIVERY':
                    return {
                        nome: i18n.t('delivery'),
                        descrizione: i18n.t('delivery_description'),
                        img: '/img/be/ico-delivery.png',
                    };
                case 'MANGIA_RISTORANTE':
                    return {
                        nome: i18n.t('eat_at_restaurant'),
                        descrizione: getters.specificTranslation('ordina_consuma_tipo_ristorante'),
                        img: '/img/be/ico-mangia-ristorante.png',
                    };
                case 'DIL':
                    return {
                        nome: overrideName ? overrideName : i18n.t('dil'), //TODO
                        descrizione: i18n.t('dil_description'),
                        img: '/img/be/ico-dil.png',
                    };
                case 'ORDINA_TAVOLO':
                    return {
                        nome: 'ORDINA AL TAVOLO',
                        descrizione: getters.specificTranslation('ordina_consuma_tavolo'),
                        img: '/img/be/ico-ordina-tavolo.png',
                    };
                case 'PRENOTAZIONI':
                    return {
                        nome: i18n.t('layout_prenota_tooltip'),
                        descrizione: null,
                        img: '/img/be/ico-prenota-tavolo.png',
                    };
                default:
                    return {
                        nome: 'Errore tipo ordine',
                        descrizione: null,
                        img: null,
                    };
            }
        }
    },
    actions: {
        setLocale({commit, state}, locale) {
            commit({
                type: SET_LOCALE,
                locale
            })
        },
        setLocali({commit, state}, locali) {
            commit({
                type: SET_LOCALI,
                locali
            })
        },
        initialize({commit, state, getters, dispatch}, params) {
            commit({
                type: INITIALIZE,
                id: params.id,
                targa: params.targa,
                impostazioni: params.impostazioni,
                locali: params.locali,
                servizi_attivi: params.servizi_attivi,
                monete: params.monete,
                punti_di_servizio: params.punti_di_servizio,
                franchising: params.franchising,
                f_stripe: params.f_stripe,
                f_modalita_fiera: params.f_modalita_fiera,
                f_distretto: params.f_distretto,
                specific_translations: params.specific_translations,
                f_deliverect: params.f_deliverect
            });

            if (state.locale) {
                commit({
                    type: SET_LOCALE,
                    locale: params.locali.find((locale) => {
                        return locale.id === state.locale.id;
                    })
                });
            } else {
                if (!getters.isMultiChoice) {
                    const room = getters.rooms()[0];
                    if (params.f_distretto || (params.f_modalita_fiera && params.punti_di_servizio && params.punti_di_servizio.length)) {
                        const service = getters.restaurantServices()[0];
                        if (service === "DIL") {
                            const point = params.punti_di_servizio[0];
                            dispatch('order/setDefaultParams', {
                                id_punto_di_servizio_default: point?.id,
                                type_default: service
                            }, {root: true});
                        }
                    }

                    commit({
                        type: SET_LOCALE,
                        locale: room
                    });
                }
            }
        }
    }

};

export default restaurant;
